import { ConversationMessageDto } from '@endion/types';
import { MessageContent } from './message-content';

export function UserMessage({ message }: { message: ConversationMessageDto }) {
  return <MessageContent role="user" content={message.content} />;
}
